import React, { useEffect, useState } from "react";
import "./scss/guage.scss";
function GuageWidget(props) {
  const score = Math.floor(props.score);
  const [rotation, setRotation] = useState(
    `calc((270deg/2) * ${props.score} / 100)`
  );

  const [fixrotation, setFixrotation] = useState(`calc( ${rotation}  * 2 )`);

  useEffect(() => {
    const roundedScore = Math.floor(props.score);
    setRotation(`calc((270deg/2) * ${roundedScore} / 100)`);
    setFixrotation(`calc(calc((270deg/2) * ${roundedScore} / 100) * 2)`);
  }, [props.score]);

  return (
    <>
      <div className="radial-progress">
        <div className="circle">
          <div
            className="mask left"
            style={{
              transform: `rotate(${rotation})`,
            }}
          >
            <div
              className="fill"
              style={{
                transform: `rotate(${rotation})`,
                "background-color": `${props.color}`,
              }}
            ></div>
          </div>
          <div className="mask right">
            <div
              className="fill"
              style={{
                transform: `rotate(${rotation})`,
                "background-color": `${props.color}`,
              }}
            ></div>
            <div
              className="fill fix"
              style={{
                transform: `rotate(${fixrotation})`,
                "background-color": `${props.color}`,
              }}
            ></div>
          </div>
        </div>
        {/* <div id="meter" className="meter" data-percent={props.score + "%"}> */}
        <div id="meter" className="meter" data-percent={`${score}%`}>
          <div className="nums">
            {" "}
            <div className="nums1"></div>
          </div>

          <span className="line-1"></span>
          <span className="line-2"></span>
        </div>
        <div
          className="pointer"
          style={{
            transform: `rotate(${fixrotation})`,
          }}
        ></div>
      </div>
    </>
  );
}
export default GuageWidget;
